import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { SpinnerComponent } from '../spinner/spinner.component';
import { CommonModule } from '@angular/common';
import { Tip } from '../../../shared/models/tip';
import { AbstractControl, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TipsService } from '../../../shared/services/tips.service';

@Component({
  selector: 'manage-tip',
  standalone: true,
  imports: [
    CommonModule,
    SpinnerComponent,
    ReactiveFormsModule
  ],
  templateUrl: './manage-tip.component.html',
  styleUrl: './manage-tip.component.css'
})
export class ManageTipComponent implements OnInit, OnChanges {

  @Input() tip!: Tip;
  @Output() onClose = new EventEmitter<void>();
  @Output() onSave = new EventEmitter<{ type: string, message: string }>();

  manageForm: FormGroup = new FormGroup({});

  messageModal: string | null = null;
  popupMessage: string | null = null;
  loading: boolean = false;

  constructor(
    private tipsService: TipsService
  ) {}

  ngOnInit(): void {
    this.initializeForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tip'] && this.tip) {
      this.initializeForm();
    }
  }

  private initializeForm(): void {
    this.manageForm = new FormGroup({
      // new_status: new FormControl(this.tip?.status ?? '0', [Validators.required, this.statusChangedValidator(this.tip?.status)]),
      new_status: new FormControl(this.tip?.status ?? '0', Validators.required),
      note: new FormControl(''),
    });

    // users have to change the status of the tip to a different one
    // this.manageForm.get('new_status')?.valueChanges.subscribe((value) => {
    //   const newStatusControl = this.manageForm.get('new_status');
    //   if (value == this.tip!.status) {
    //     newStatusControl?.setErrors({ statusUnchanged: true });
    //   } else {
    //     // Remove the custom error if it was previously set
    //     if (newStatusControl?.hasError('statusUnchanged')) {
    //       newStatusControl.updateValueAndValidity({ onlySelf: true, emitEvent: false });
    //       newStatusControl.setErrors(null);
    //     }
    //   }
    // });
  }

  // function to check if users change new status to a different one
  // if not, it will return an error
  private statusChangedValidator(originalStatus: number | undefined) {
    return (control: AbstractControl) => {
      if (control.value == null || originalStatus == null) {
        return { statusUnchanged: true }; // invalid if nothing selected
      }
      return control.value === originalStatus
        ? { statusUnchanged: true }
        : null;
    };
  }

  onSubmit(): void {
    if (this.manageForm.valid && this.tip?.id) {
      const fromValue = this.manageForm.value;
      fromValue.new_status = Number(fromValue.new_status);
      this.loading = true;
      this.tipsService.updateTipStatus(this.tip.id, fromValue.new_status, fromValue.note).subscribe({
        next: (response) => {
          this.loading = false;
          console.log(response);
          this.onSave.emit({'type': 'success', 'message': 'The tip status has been changed.'});
        },
        error: (error) => {
          this.loading = false;
          console.error(error.message);
          this.onSave.emit({type: 'failed', 'message': error.message});
        }
      });
      console.log('Form submitted:', fromValue);
    }
  }  

  handleCloseManage(): void {
    this.onClose.emit();
  }
  
  resetMessageModal(): void {
    this.messageModal = null;
    this.popupMessage = null;
    this.onClose.emit();
  }
}
